module.exports = __webpack_public_path__ + "da8e6ec177d1fef591a0e794374d5142.jpg";